<div class="pi-modal-bono" role="dialog" aria-labelledby="pi-modal-bono-title">
  <header class="pi-modal-bono__header">
    <div class="pi-modal-bono__header-main">
      <span class="pi-modal-bono__header-info" aria-hidden="true">
        <ds-icon name="InfoFill" size="32px"></ds-icon>
      </span>
      <div class="pi-modal-bono__header-text">
        <h2 id="pi-modal-bono-title" class="pi-modal-bono__title">
          Bono Amortizable: así se paga tu nuevo aporte
        </h2>
      </div>
    </div>
    <ds-icon-button-v2
      class="pi-modal-bono__close"
      icon="Close"
      size="s"
      emphasis="terciary"
      ariaLabel="Cerrar"
      (clicked)="cerrar()">
    </ds-icon-button-v2>
  </header>

  <div class="pi-modal-bono__body">
    <div class="pi-modal-bono__content">
      <div class="pi-modal-bono__main">
        <p class="pi-modal-bono__text">
          Desde agosto de 2026, tu empleador aporta un 0,9% adicional a tu remuneración imponible
          para aumentar tu futura pensión. Este monto no se descuenta de tu sueldo y su rentabilidad
          está protegida por ley.
        </p>
        <p class="pi-modal-bono__text">
          Al pensionarte, este beneficio se transforma en
          <strong>Bono Amortizable</strong> y se suma a tu pensión.
        </p>

        <div class="pi-modal-bono__cards">
          <article *ngFor="let opcion of opciones" class="pi-modal-bono__card">
            <div class="pi-modal-bono__card-row">
              <span class="pi-modal-bono__card-icon" aria-hidden="true">
                <ds-icon [name]="opcion.icon" size="20px"></ds-icon>
              </span>
              <div class="pi-modal-bono__card-text">
                <p class="pi-modal-bono__card-condition">
                  {{ opcion.condition }}<strong>{{ opcion.conditionBold }}</strong>
                </p>
                <p class="pi-modal-bono__card-result">{{ opcion.result }}</p>
              </div>
            </div>
          </article>
        </div>

        <p class="pi-modal-bono__text">
          El Administrador del Fondo Autónomo de Protección Previsional (AFAPP) gestiona este pago
          por ti, sin trámites adicionales de tu parte.
        </p>
        <p class="pi-modal-bono__text">
          Puedes revisar tus aportes, rentabilidad y montos acumulados en la sección
          <button type="button" class="pi-modal-bono__link" (click)="irAReformaPensiones($event)">
            Reforma de Pensiones
          </button>.
        </p>
      </div>

      <aside class="pi-modal-bono__alert" role="note">
        <span class="pi-modal-bono__alert-icon" aria-hidden="true">
          <ds-icon name="InfoFill" size="24px"></ds-icon>
        </span>
        <p class="pi-modal-bono__alert-text">
          De acuerdo con lo establecido en el artículo 8, inciso octavo, de la Ley N° 21.735 el
          AFAPP está mandatado por el solo ministerio de la ley para realizar el endoso del bono
          amortizable en representación del afiliado. La posibilidad de endoso del bono amortizable
          podrá materializarse en cualquier momento desde que aquel es emitido y hasta antes del
          pago de la última de sus 240 cuotas.
        </p>
      </aside>
    </div>
  </div>

  <footer class="pi-modal-bono__footer">
    <ds-button-v2
      class="pi-modal-bono__cta"
      [label]="ctaLabel"
      emphasis="primary"
      size="m"
      (clicked)="confirmar()">
    </ds-button-v2>
  </footer>
</div>
